<form
    class="auth-container auth-form"
    [formGroup]="loginForm"
    [loading]="isLoading"
    (ngSubmit)="submit()"
>
    <h1 class="form-header">{{ meta.form.title }}</h1>

    <ul class="edge-form-group column">
        <li class="form-group-ctrl">
            <mat-form-field>
                <mat-label for="login-username">Username</mat-label>
                <input
                    matInput
                    placeholder="Enter your username"
                    type="text"
                    id="login-username"
                    formControlName="username"
                    required
                />
                <mat-error>
                    <dui-validation-error [control]="loginForm.controls.username"></dui-validation-error>
                </mat-error>
            </mat-form-field>
        </li>
        <li class="form-group-ctrl">
            <mat-form-field>
                <mat-label for="login-password">Password</mat-label>
                <input
                    matInput
                    placeholder="Enter your password"
                    type="password"
                    id="login-password"
                    formControlName="password"
                    required
                />
                <mat-error>
                    <dui-validation-error
                        [control]="loginForm.controls.password"
                        [customMessages]="passwordCustomErrors">
                    </dui-validation-error>
                </mat-error>
            </mat-form-field>

            <div id="login-message" [hidden]="!hasMessage" class="message">{{ message }}</div>
        </li>
        <li class="form-group-ctrl checkbox">
            <mat-checkbox
                formControlName="remember"
                color="primary"
                class="remember-email"
                id="login-remember"
            >Remember Me</mat-checkbox>
        </li>
        <li class="form-group-ctrl">
            <div class="ctrl-wrapper wide">
                <button
                    mat-flat-button
                    color="primary"
                    id="login-submit"
                    type="submit"
                    class="big bold"
                    [disabled]="loginForm.invalid"
                >SUBMIT</button>
            </div>
        </li>
    </ul>

    <div class="form-links">
        <a id="login-help"
            class="form-link"
            routerLink="/auth/login-help">
            Trouble Logging In?
        </a>
        <a id="login-register"
            class="form-link"
            routerLink="/auth/register">
            Register
        </a>
    </div>

</form>
